import { Box, Button, Card, CardContent, Grid, Grid2, Tab, Tabs } from "@mui/material";
import AuthSection from "../../components/general/AuthSection";
import TabPanel from "../../components/general/TabPanel";
import { useEffect, useState } from "react";
import DataSantri from "../../components/Daftar/DataSantri";
import DataAyah from "../../components/Daftar/DataAyah";
import DataIbu from "../../components/Daftar/DataIbu";
import { Commons } from "../../helper/CommonService";
import { API_HOST } from "../../helper/Constant";
import LoadingButton from "@mui/lab/LoadingButton";
import { Save } from "@mui/icons-material";
import ShowNotif from "../../components/general/ShowNotif";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSkeleton from "../../components/general/LoadingSkeleton";
import DataWali from "../../components/Daftar/DataWali";

function EditData() {
    const navigate = useNavigate(); // Initialize the navigate function
    const { idSantri } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [panelValue, setPanelValue] = useState(0);
    const [dataRegister, setDataRegister] = useState(null);
    const [isShowNotif, setIsShowNotif] = useState(false);
    const [notifData, setNotifData] = useState({});
    const ChangeDataSantri = (propertyName, propertyValue) => {
        setDataRegister(prev => ({
            ...prev,
            [propertyName]: propertyValue
        }));
    }

    const ChangeDataAyah = (propertyName, propertyValue) => {
        setDataRegister(prev => ({
            ...prev,
            data_ayah: [{
                ...prev.data_ayah[0],
                [propertyName]: propertyValue
            }]
        }));
    }
    const ChangeDataIbu = (propertyName, propertyValue) => {
        setDataRegister(prev => ({
            ...prev,
            data_ibu: [{
                ...prev.data_ibu[0],
                [propertyName]: propertyValue
            }]
        }));
    }
    const ChangeDataWali = (propertyName, propertyValue) => {
        setDataRegister(prev => ({
            ...prev,
            data_wali: [{
                ...prev.data_wali[0],
                [propertyName]: propertyValue
            }]
        }));
    }

    const UpdateData = () => {
        setIsLoading(true);
        Commons.UpdateData(API_HOST + "/items/data_santris/" + idSantri, dataRegister, true)
            .then((responseUpdate) => {
                setNotifData({
                    "status": "success",
                    "message": "Update data successfully"
                });
            })
            .catch((responseError) => {
                console.log(responseError);
                setNotifData({
                    "status": "error",
                    "message": "Update data Gagal"
                });
            })
            .finally(() => {
                setIsShowNotif(true);
                setIsLoading(false);
            });
    };

    useEffect(() => {
        Promise.all([
            Commons.GetDetailData(API_HOST + "/items/data_santris/" + idSantri + '?fields=*,data_ayah.*,data_ibu.*,data_wali.*', true),
        ])
            .then(([dataResponseRegister]) => {
                if (dataResponseRegister) {
                    setDataRegister(dataResponseRegister);
                }
            });

    }, []);

    const RenderData = () => {
        if (!dataRegister) {
            return (
                <>
                    <LoadingSkeleton size={4}></LoadingSkeleton>
                </>
            )
        }
        return (
            <>
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs variant="fullWidth" TabIndicatorProps={{
                            style: { width: 'fit-content' } // Match indicator to label width
                        }}
                            sx={{
                                '& .MuiTabs-indicator': {
                                    backgroundColor: '#1976d2',
                                },
                                '& .MuiTab-root': {
                                    fontWeight: "bold",
                                    textTransform: 'none',
                                    padding: '6px 16px', // Ensure consistent padding
                                }
                            }} value={panelValue} onChange={(event, newValue) => { setPanelValue(newValue); }}>
                            <Tab label="Data Pribadi"></Tab>
                            <Tab label="Data Ayah"></Tab>
                            <Tab label="Data Ibu"></Tab>
                            {dataRegister?.data_wali !== null ? <Tab label="Data Wali"></Tab> : <></>}
                        </Tabs>
                    </Box>
                    <TabPanel value={panelValue} index={0}>
                        <DataSantri data={dataRegister} handleChange={ChangeDataSantri}></DataSantri>
                    </TabPanel>
                    <TabPanel value={panelValue} index={1}>
                        <DataAyah data={dataRegister?.data_ayah?.[0]} handleChange={ChangeDataAyah}></DataAyah>
                    </TabPanel>
                    <TabPanel value={panelValue} index={2}>
                        <DataIbu data={dataRegister?.data_ibu?.[0]} handleChange={ChangeDataIbu}></DataIbu>
                    </TabPanel>
                    {
                        dataRegister?.data_wali !== null ?
                            <TabPanel value={panelValue} index={3}>
                                <DataWali data={dataRegister?.data_wali?.[0]} handleChange={ChangeDataWali}></DataWali>
                            </TabPanel>
                            :
                            <></>
                    }
                    <Grid sx={{ padding: "10px" }} container spacing={2}>
                        <Grid sx={{ padding: "5px" }} xs={6} xl={6} lg={6} sm={6} md={6}>
                            <LoadingButton
                                fullWidth
                                sx={{ backgroundColor: '#e96726' }}
                                startIcon={<Save></Save>}
                                loadingPosition="start" variant="contained"
                                loading={isLoading}
                                onClick={UpdateData}>
                                {isLoading ? "Processing" : "Simpan"}
                            </LoadingButton>
                        </Grid>
                        <Grid sx={{ padding: "5px" }} xs={6} xl={6} lg={6} sm={6} md={6}>
                            <Button fullWidth variant="contained" color="error" onClick={() => {
                                navigate('/main');
                            }}>Cancel/Kembali</Button>
                        </Grid>

                    </Grid>


                </Box>
            </>
        )
    }

    return (
        <>
            <AuthSection></AuthSection>
            <ShowNotif actionClose={() => { setIsShowNotif(false) }} data={notifData} isShow={isShowNotif}></ShowNotif>
            <Grid2 sx={{ backgroundColor: "#FFFFFF", padding: "10px" }} container spacing={2}>
                <Grid2>
                    {RenderData()}
                </Grid2>
            </Grid2>

        </>
    )
}
export default EditData;